export default "__VITE_ASSET__X5PJR6xp__"